function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import axios from 'axios';
import AxiosUtils from '../../utilities/axios-utils';
import ConfigurationManager from '../configuration-manager';

/**
 * @memberOf module:wdh-feature-b2b
 */
var ApiClientBulkOrder = /*#__PURE__*/function () {
  function ApiClientBulkOrder(token) {
    _classCallCheck(this, ApiClientBulkOrder);
    this.token = token;
  }
  return _createClass(ApiClientBulkOrder, [{
    key: "initErrorHandling",
    value: function initErrorHandling(callback) {
      this.errorHandlingCallback = callback;
    }

    /**
     * Adds a bulk order
     */
  }, {
    key: "add",
    value: function add(bulkOrder) {
      var _this = this;
      var promise = new Promise(function (resolve, reject) {
        axios.post('/api/shop/bulk-orders', bulkOrder, AxiosUtils.getConfig(ConfigurationManager.getUSOrdersServiceEndPoint(), _this.token)).then(function (response) {
          if (response.status === 401) {
            // force user to log in.
            window.location.reload();
          }
          resolve(response.data);
        }).catch(function (err) {
          reject(err);
          _this.errorHandlingCallback(err.response.data);
        });
      });
      return promise;
    }

    /**
     * Adds an array of bulk orders to cart
     */
  }, {
    key: "addMultipleOrders",
    value: function addMultipleOrders(bulkOrder) {
      var _this2 = this;
      var promise = new Promise(function (resolve, reject) {
        axios.post('/api/shop/bulk-orders/bulk-add', bulkOrder, AxiosUtils.getConfig(ConfigurationManager.getUSOrdersServiceEndPoint(), _this2.token)).then(function (response) {
          if (response.status === 401) {
            // force user to log in.
            window.location.reload();
          }
          resolve(response.data);
        }).catch(function (err) {
          reject(err);
          _this2.errorHandlingCallback(err.response.data);
        });
      });
      return promise;
    }

    /**
     * Deletes all bulk orders from cart
     */
  }, {
    key: "deleteAll",
    value: function deleteAll() {
      var _this3 = this;
      var promise = new Promise(function (resolve, reject) {
        axios.delete('/api/shop/bulk-orders/delete-all', AxiosUtils.getConfig(ConfigurationManager.getUSOrdersServiceEndPoint(), _this3.token)).then(function (response) {
          resolve(response.data);
        }).catch(function (err) {
          reject(err);
          _this3.errorHandlingCallback(err.response.data);
        });
      });
      return promise;
    }

    /**
     * Updates a bulk order
     */
  }, {
    key: "update",
    value: function update(bulkOrder) {
      var _this4 = this;
      var promise = new Promise(function (resolve, reject) {
        axios.post('/api/shop/bulk-orders/update', bulkOrder, AxiosUtils.getConfig(ConfigurationManager.getUSOrdersServiceEndPoint(), _this4.token)).then(function (response) {
          resolve(response.data);
        }).catch(function (err) {
          reject(err);
          _this4.errorHandlingCallback(err.response.data);
        });
      });
      return promise;
    }

    /**
     * Updates an array of bulk orders
     */
  }, {
    key: "updateMultipleOrders",
    value: function updateMultipleOrders(bulkOrder) {
      var _this5 = this;
      var promise = new Promise(function (resolve, reject) {
        axios.post('/api/shop/bulk-orders/bulk-update', bulkOrder, AxiosUtils.getConfig(ConfigurationManager.getUSOrdersServiceEndPoint(), _this5.token)).then(function (response) {
          resolve(response.data);
        }).catch(function (err) {
          reject(err);
          _this5.errorHandlingCallback(err.response.data);
        });
      });
      return promise;
    }

    /**
     * Retrieves a bulk order based on bulk order ID
     */
  }, {
    key: "get",
    value: function get(bulkOrderId) {
      var _this6 = this;
      var promise = new Promise(function (resolve, reject) {
        axios.get("/api/shop/bulk-orders/".concat(bulkOrderId), AxiosUtils.getConfig(ConfigurationManager.getUSOrdersServiceEndPoint(), _this6.token)).then(function (response) {
          resolve(response.data);
        }).catch(function (err) {
          reject(err);
          _this6.errorHandlingCallback(err.response.data);
        });
      });
      return promise;
    }

    /**
     * Adds a coupon to a bulk order
     * @param {string} bulkOrderId
     * @param {object} coupon
     */
  }, {
    key: "addCoupon",
    value: function addCoupon(bulkOrderId, coupon) {
      var _this7 = this;
      return new Promise(function (resolve, reject) {
        axios.post("/api/shop/bulk-orders/".concat(bulkOrderId, "/coupon"), coupon, AxiosUtils.getConfig(ConfigurationManager.getUSOrdersServiceEndPoint(), _this7.token)).then(function (response) {
          resolve(response.data);
        }).catch(function (err) {
          reject(err);
          _this7.errorHandlingCallback(err.response.data);
        });
      });
    }

    /**
     * Removes coupon from a bulk order
     * @param {string} bulkOrderId
     */
  }, {
    key: "deleteCoupon",
    value: function deleteCoupon(bulkOrderId) {
      var _this8 = this;
      var promise = new Promise(function (resolve, reject) {
        axios.delete("/api/shop/bulk-orders/".concat(bulkOrderId, "/coupon"), AxiosUtils.getConfig(ConfigurationManager.getUSOrdersServiceEndPoint(), _this8.token)).then(function (response) {
          resolve(response.data);
        }).catch(function (err) {
          reject(err);
          _this8.errorHandlingCallback(err.response.data);
        });
      });
      return promise;
    }

    /**
     * Adds a coupon to a related product for a bulk order
     * @param {string} bulkOrderId
     * @param {string} relatedProductId
     * @param {object} coupon
     */
  }, {
    key: "addCouponRelated",
    value: function addCouponRelated(bulkOrderId, relatedProductId, coupon) {
      var _this9 = this;
      var promise = new Promise(function (resolve, reject) {
        axios.post("/api/shop/bulk-orders/".concat(bulkOrderId, "/coupon/related/").concat(relatedProductId), coupon, AxiosUtils.getConfig(ConfigurationManager.getUSOrdersServiceEndPoint(), _this9.token)).then(function (response) {
          resolve(response.data);
        }).catch(function (err) {
          reject(err);
          _this9.errorHandlingCallback(err.response.data);
        });
      });
      return promise;
    }

    /**
     * Removes coupon from a bulk order
     * @param {string} bulkOrderId
     */
  }, {
    key: "deleteCouponRelated",
    value: function deleteCouponRelated(bulkOrderId, relatedProductId) {
      var _this0 = this;
      var promise = new Promise(function (resolve, reject) {
        axios.delete("/api/shop/bulk-orders/".concat(bulkOrderId, "/coupon/related/").concat(relatedProductId), AxiosUtils.getConfig(ConfigurationManager.getUSOrdersServiceEndPoint(), _this0.token)).then(function (response) {
          resolve(response.data);
        }).catch(function (err) {
          reject(err);
          _this0.errorHandlingCallback(err.response.data);
        });
      });
      return promise;
    }

    /**
     * Gets the available categories for the bulk order related products selector
     */
  }, {
    key: "getRelatedCategories",
    value: function getRelatedCategories() {
      var _this1 = this;
      var promise = new Promise(function (resolve, reject) {
        axios.get('/api/category/catalogStructure/quickOrder', AxiosUtils.getConfig(ConfigurationManager.getShopServiceEndPoint(), _this1.token)).then(function (response) {
          resolve(response.data);
        }).catch(function (err) {
          reject(err);
          _this1.errorHandlingCallback(err.response.data);
        });
      });
      return promise;
    }

    /**
     * returns a boolean value if the current product is a rechargeable item or not.
     *
     * @param {string} itemNumber
     */
  }, {
    key: "getIsRechargeable",
    value: function getIsRechargeable(itemNumber) {
      var _this10 = this;
      return new Promise(function (resolve, reject) {
        axios.get("api/shop/bulk-orders/isRechargeable/".concat(itemNumber), AxiosUtils.getConfig(ConfigurationManager.getUSOrdersServiceEndPoint(), _this10.token)).then(function (response) {
          resolve(response.data);
        }).catch(function (err) {
          reject(err);
          _this10.errorHandlingCallback(err.response.data);
        });
      });
    }

    /**
     * returns a boolean value if the current product is a smartCharger item or not.
     *
     * @param {string} itemNumber
     */
  }, {
    key: "getIsSmartCharger",
    value: function getIsSmartCharger(itemNumber) {
      var _this11 = this;
      return new Promise(function (resolve, reject) {
        axios.get("api/shop/bulk-orders/isSmartCharger/".concat(itemNumber), AxiosUtils.getConfig(ConfigurationManager.getUSOrdersServiceEndPoint(), _this11.token)).then(function (response) {
          resolve(response.data);
        }).catch(function (err) {
          reject(err);
          _this11.errorHandlingCallback(err.response.data);
        });
      });
    }
  }]);
}();
export default ApiClientBulkOrder;